/**
 * "10 ההצעות האחרונות" + מספר הצעות היום/החודש — TASKS 5.3, PRD 8.2.
 *
 * ⭐ זו נקודת הראייה של טל להצעה חדשה שנכנסה — ⛔ אין "ממתין לשליחה" (PRD
 *    8.2: "הכול אוטומטי"), רק רשימה + כפתור שליחה ידנית בוואטסאפ לכל שורה.
 */
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { isAdminApiError } from './adminApi.js';
import { getQuoteStats, listQuotes, type QuoteListItem } from './quotesApi.js';
import { WhatsAppSendButton } from './WhatsAppSendButton.js';

export function RecentQuotesPanel() {
  const [quotes, setQuotes] = useState<QuoteListItem[] | null>(null);
  const [stats, setStats] = useState<{ todayCount: number; monthCount: number } | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    Promise.all([listQuotes({ pageSize: 10 }), getQuoteStats()])
      .then(([quotesResult, statsResult]) => {
        if (cancelled) return;
        setQuotes(quotesResult.quotes);
        setStats(statsResult);
      })
      .catch((err: unknown) => {
        if (!cancelled)
          setError(isAdminApiError(err) ? err.message : 'שגיאה בטעינת הצעות אחרונות.');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section
      className="border-line bg-surface mt-6 rounded-lg border p-6"
      aria-labelledby="recent-quotes-h"
    >
      <div className="flex flex-wrap items-center justify-between gap-2">
        <h2 id="recent-quotes-h" className="text-lg font-semibold">
          הצעות אחרונות
        </h2>
        <Link to="/admin/quotes" className="text-sm">
          כל הארכיון
        </Link>
      </div>

      {stats && (
        <p className="text-muted mt-1 text-sm">
          היום: {stats.todayCount} · החודש: {stats.monthCount}
        </p>
      )}

      {error && (
        <p role="alert" className="text-danger mt-3 text-sm">
          {error}
        </p>
      )}

      {quotes === null && !error && <p className="text-muted mt-3 text-sm">טוען…</p>}
      {quotes && quotes.length === 0 && <p className="text-muted mt-3 text-sm">אין עדיין הצעות.</p>}

      {quotes && quotes.length > 0 && (
        <ul className="mt-3 space-y-2">
          {quotes.map((quote) => (
            <li
              key={quote.id}
              className="border-line flex flex-wrap items-center justify-between gap-2 rounded border p-2 text-sm"
            >
              <span>
                <Link to={`/admin/quotes/${quote.id}`} className="ltr-inline font-semibold">
                  {quote.quote_number}
                </Link>{' '}
                - {quote.customer_full_name} - <span className="tabular">₪{quote.total}</span>
              </span>
              {Boolean(quote.has_pdf) && (
                <WhatsAppSendButton quoteId={quote.id} quoteNumber={quote.quote_number} />
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
